import { render, staticRenderFns } from "./MpollutionalertsauthoritiesForm.vue?vue&type=template&id=0927b358"
import script from "./MpollutionalertsauthoritiesForm.vue?vue&type=script&lang=js"
export * from "./MpollutionalertsauthoritiesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports